<div class="login-wrap">
  <div class="login-card">

    <div class="app-icon">🛒</div>
    <h1 class="login-title">Don't waste</h1>

    @if (view === 'add-member') {

      <p class="login-sub">Nieuw gezinslid toevoegen</p>

      @if (addMemberStatus) {
        <div class="add-member-status" [class.add-member-error]="addMemberIsError">{{ addMemberStatus }}</div>
      }

      @if (!addMemberIsError && addMemberStatus) {
        <button class="submit-btn" (click)="backToMembers()">Terug naar overzicht</button>
      } @else {
        <div class="add-member-form">
          <div class="field-block">
            <label class="field-label">Gebruikersnaam</label>
            <input class="field-input" [(ngModel)]="newUsername" placeholder="Naam gezinslid" autocomplete="off">
          </div>
          <div class="field-block">
            <label class="field-label">E-mailadres</label>
            <input class="field-input" [(ngModel)]="newEmail" type="email" autocomplete="email">
          </div>
          <div class="field-block">
            <label class="field-label">Pincode</label>
            <div class="pin-wrap">
              <input class="field-input pin-input" [(ngModel)]="newPin"
                     [type]="newShowPin ? 'text' : 'password'"
                     inputmode="numeric" autocomplete="new-password">
              <button type="button" class="pin-toggle" (click)="newShowPin = !newShowPin">
                {{ newShowPin ? 'Verberg' : 'Toon' }}
              </button>
            </div>
          </div>
          <button class="submit-btn" (click)="submitAddMember()"
                  [disabled]="addMemberLoading || !newUsername.trim() || !newEmail.trim() || !newPin.trim()">
            {{ addMemberLoading ? 'Bezig…' : 'Toevoegen' }}
          </button>
        </div>
        <button class="change-family-btn" (click)="backToMembers()">Annuleren</button>
      }

    } @else if (view === 'members') {

      <p class="login-sub">{{ familyName || 'Kies wie je bent' }}</p>

      @if (membersLoading) {
        <p class="loading-text">Laden…</p>
      } @else if (membersError) {
        <div class="status-error">{{ membersError }}</div>
      } @else {
        <div class="members-grid">
          @for (member of members; track member.id) {
            <button class="member-card" (click)="selectMember(member)">
              <span class="member-avatar">{{ member.name[0].toUpperCase() }}</span>
              <span class="member-name">{{ member.name }}</span>
            </button>
          }
          <button class="member-card member-card-add" (click)="showAddMember()">
            <span class="member-avatar member-avatar-add">+</span>
            <span class="member-name">Toevoegen</span>
          </button>
        </div>
      }

      <button class="change-family-btn" (click)="changeFamily()">Andere familie</button>

    } @else {

      <p class="login-sub">Hoi {{ selectedUser?.name }}, voer je pincode in</p>

      @if (statusText) {
        <div class="{{statusClass}}">{{ statusText }}</div>
      }

      <div class="dots">
        <div class="{{inputCode.length > 0 ? 'dotfilled' : 'dot'}}"></div>
        <div class="{{inputCode.length > 1 ? 'dotfilled' : 'dot'}}"></div>
        <div class="{{inputCode.length > 2 ? 'dotfilled' : 'dot'}}"></div>
        <div class="{{inputCode.length > 3 ? 'dotfilled' : 'dot'}}"></div>
        <div class="{{inputCode.length > 4 ? 'dotfilled' : 'dot'}}"></div>
      </div>

      <div class="numpad">
        <div class="num-pad" (click)="add(1)">1</div>
        <div class="num-pad" (click)="add(2)">2</div>
        <div class="num-pad" (click)="add(3)">3</div>
        <div class="num-pad" (click)="add(4)">4</div>
        <div class="num-pad" (click)="add(5)">5</div>
        <div class="num-pad" (click)="add(6)">6</div>
        <div class="num-pad" (click)="add(7)">7</div>
        <div class="num-pad" (click)="add(8)">8</div>
        <div class="num-pad" (click)="add(9)">9</div>
        <div class="num-pad action" (click)="backToMembers()">←</div>
        <div class="num-pad" (click)="add(0)">0</div>
        <div class="num-pad action" (click)="del()">⌫</div>
      </div>

      @if (pinRequestStatus) {
        <div class="pin-request-status" [class.pin-request-error]="pinRequestIsError">{{ pinRequestStatus }}</div>
      }

      <button class="forgot-pin-btn" (click)="requestPin()" [disabled]="pinRequestLoading">
        {{ pinRequestLoading ? 'Versturen…' : 'Pincode vergeten?' }}
      </button>

    }

  </div>

  <button class="install-btn" id="install" hidden>Installeer app</button>
</div>
